export enum ShareMethod {
	FACEBOOK = 'facebook',
	TWITTER = 'twitter',
	CLIPBOARD = 'clipboard',
}
